module.exports = __webpack_public_path__ + "media/cladtech/about-aluminium-image-1-11c4c859.jpg";